import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { Switch } from '../../components/ui/switch';
const ShadcnSwitch = ({ formrValue, onUpdate, readonly = false }) => {
    // Ties the label to its control, so the field has an accessible name.
    const id = useId();
    const isDisabled = readonly || !formrValue.editable(formrValue.value);
    return (_jsxs("div", { className: "flex w-full items-center justify-between py-1", children: [_jsx("label", { htmlFor: id, className: "text-sm font-medium text-foreground", children: formrValue.label }), _jsx(Switch, { id: id, checked: !!formrValue.value, onCheckedChange: (checked) => {
                    onUpdate(formrValue.key, formrValue.setter(checked));
                }, disabled: isDisabled })] }));
};
export { ShadcnSwitch };
//# sourceMappingURL=ShadcnSwitch.js.map